export default "__VITE_ASSET__D6vLs_zu__"